import { render, staticRenderFns } from "./PretRelais.vue?vue&type=template&id=3cc43b18&scoped=true&"
import script from "./PretRelais.vue?vue&type=script&lang=js&"
export * from "./PretRelais.vue?vue&type=script&lang=js&"
import style0 from "./PretRelais.vue?vue&type=style&index=0&id=3cc43b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc43b18",
  null
  
)

export default component.exports